module.exports = __webpack_public_path__ + "static/media/wip-white.8be97e5a.svg";